/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Merge_Replace_LabelInputs */

const en_plain_text_import_merge_replace_label = /** @type {(inputs: Plain_Text_Import_Merge_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge/Replace Events`)
};

const fr_plain_text_import_merge_replace_label = /** @type {(inputs: Plain_Text_Import_Merge_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionner/Remplacer les evenements`)
};

const de_plain_text_import_merge_replace_label = /** @type {(inputs: Plain_Text_Import_Merge_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenführen/Ersetzen von Ereignissen`)
};

const it_plain_text_import_merge_replace_label = /** @type {(inputs: Plain_Text_Import_Merge_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisci/Sostituisci eventi`)
};

const ru_plain_text_import_merge_replace_label = /** @type {(inputs: Plain_Text_Import_Merge_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объединение/замена событий`)
};

const es_plain_text_import_merge_replace_label = /** @type {(inputs: Plain_Text_Import_Merge_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionar/Reemplazar eventos`)
};

const zh_cn2_plain_text_import_merge_replace_label = /** @type {(inputs: Plain_Text_Import_Merge_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并/替换事件`)
};

const ja_plain_text_import_merge_replace_label = /** @type {(inputs: Plain_Text_Import_Merge_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントの結合/置換`)
};

const hi_plain_text_import_merge_replace_label = /** @type {(inputs: Plain_Text_Import_Merge_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटनाओं को मर्ज/प्रतिस्थापित करें`)
};

const pt_pt2_plain_text_import_merge_replace_label = /** @type {(inputs: Plain_Text_Import_Merge_Replace_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesclar/Substituir Eventos`)
};

/**
* | output |
* | --- |
* | "Merge/Replace Events" |
*
* @param {Plain_Text_Import_Merge_Replace_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_merge_replace_label = /** @type {((inputs?: Plain_Text_Import_Merge_Replace_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Merge_Replace_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_merge_replace_label(inputs)
	if (locale === "de") return de_plain_text_import_merge_replace_label(inputs)
	if (locale === "it") return it_plain_text_import_merge_replace_label(inputs)
	if (locale === "ru") return ru_plain_text_import_merge_replace_label(inputs)
	if (locale === "es") return es_plain_text_import_merge_replace_label(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_merge_replace_label(inputs)
	if (locale === "ja") return ja_plain_text_import_merge_replace_label(inputs)
	if (locale === "hi") return hi_plain_text_import_merge_replace_label(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_merge_replace_label(inputs)
	return en_plain_text_import_merge_replace_label(inputs)
});